<!-- 设备传感器详情 -->
<template>
    <div>
        <keep-alive>
            <sensorsidebar type="Group"></sensorsidebar>
        </keep-alive>
        <div class="content">
            <div class="pl-pannel bg-w bdrd10 pdv20 pdh30 unselect">
                <div class="pl-title lh50 xrow ai-c">
                    <div>
                        <img src="@/assets/category/te-1.png" style="margin-bottom:10px;">
                        <span v-if="!showMutiLine" class="color-m09 fs20 lsp2 fw-bd mgl10">{{ type }}实时变化数据(10秒刷新)</span>
                        <span v-if="showMutiLine" class="color-m09 fs20 lsp2 fw-bd mgl10">{{ type }}变化数据</span>
                    </div>
                    <div>
                        <span style="font-size: 20px; font-weight: bold;margin-left: 50px;margin-right: 10px;">起止时间</span>
                        <el-date-picker v-model="queryDate" type="daterange" align="right" unlink-panels range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
                        </el-date-picker>
                        <el-button type="primary" icon="el-icon-search" style="margin-left: 10px;" class="mgl15"
                            @click="MonthChange">查询</el-button>
                        <!-- <el-date-picker v-model="selectMonth" :default-value="selectMonth" type="month" placeholder="选择月"
                            v-if="showMutiLine" @change="MonthChange">
                        </el-date-picker> -->
                        <!-- <el-radio-group v-model="showMutiLine" @change="showMutiLineChange">
                            <el-radio-button :label="false">单个深度</el-radio-button>
                            <el-radio-button :label="true">4层深度</el-radio-button>
                        </el-radio-group> -->
                    </div>
                </div>
                <div class="pl-content pdt20">
                    <realchart ref="realchart" v-if="!showMutiLine"></realchart>
                    <multichart ref="mutichart" v-else></multichart>
                </div>
            </div>
            <div class="pl-pannel bg-w bdrd10 pdv20 pdh30 unselect mgt20">
                <div class="pl-title xrow ai-c jc-sb">
                    <el-form :inline="true" class=" query-form">
                        <el-form-item label="采集时间">
                            <el-date-picker v-model="queryDate" type="daterange" align="right" unlink-panels
                                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                :picker-options="pickerOptions">
                            </el-date-picker>
                        </el-form-item>
                        <!-- <el-form-item label="传感器">
                            <el-select v-model="NodeId" placeholder="请选择">
                                <el-option v-for="item in NodeOptions" :key="item.key" :label="item.label"
                                    :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item> -->
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" class="mgl15" @click="search">查询</el-button>
                        </el-form-item>
                    </el-form>
                    <div class="operate xrow ai-c jc-c">
                        <a href="javascript:void(0)" class="export" v-on:click="downLoadHistory()">导出全部</a>
                    </div>
                </div>
                <div class="pl-content pdt20">
                    <el-table :data="tableData" stripe style="width: 100%" header-row-class-name="headercolumn"
                        cell-class-name="datarow" :row-class-name="tableRowClassName">
                        <el-table-column prop="rowNum" label="序号" width="80">
                        </el-table-column>
                        <el-table-column prop="FullName" label="传感器名">
                        </el-table-column>
                        <el-table-column prop="Value" label="采集值">
                        </el-table-column>
                        <el-table-column prop="ReportTime" label="采集时间">
                        </el-table-column>
                        <!-- <el-table-column prop="AlarmStateText" label="报警状态">
                        </el-table-column>
                        <el-table-column prop="AlarmEventText" label="报警事件">
                        </el-table-column>
                        <el-table-column prop="AlarmTime" label="报警时间">
                        </el-table-column> -->
                    </el-table>
                </div>
                <div class="pl-footer xrow ai-c jc-sb mgt20">
                    <div class="paging-memo" v-if="totalTableDataCount > 0">检索到 {{ totalTableDataCount }} 条记录，显示
                        第{{ (pageIndex - 1) * pageRows + 1 }}条 - 第{{ pageIndex * pageRows }}条，查询耗时 {{ tableCostTime }} 毫秒
                    </div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page.sync="pageIndex" :page-sizes="[50, 100, 200, 300, 400]"
                        layout="total, prev, pager, next,sizes, jumper" :total="totalTableDataCount">
                    </el-pagination>
                </div>
            </div>
            <!-- <historydialog ref="historydialog"></historydialog> -->
        </div>
    </div>
</template>

<script>
import { formatDate } from '@/common/util.js'
import { objectToParams, downLoadExcel } from '@/utils/util.js'
import realchart from './realchart'
import multichart from './multichart'
import { soilDetailList, soilParamList } from "@/utils/config.js"
import { forEach } from "lodash"
import { get } from "@/utils/http";
// import historydialog from '../history/history'
import sensorsidebar from './sensorsidebar.vue'
export default {
    components: { realchart, sensorsidebar, multichart },

    data() {
        return {
            EncoderId: '',
            Encoder: {},
            Group: '',
            GroupName: '',
            NodeId: '',
            SelectNode: {},
            DataNodes: [],
            tableData: [],
            GroupNodes: [],
            NodeOptions: [],
            totalTableDataCount: 0,
            tableCostTime: 0,
            pageRows: 50,
            pageIndex: 1,
            queryDate: [
                // new Date().getTime() - 3600 * 1000 * 24 * 7,
                // new Date().getTime()
                new Date().getTime() - 3600 * 1000 * 24 * 30,
                new Date().getTime()
            ],
            pickerOptions: {},
            showMutiLine: true,
            type: "",
            queryName: "",
            valueParamList: [],
            selectMonth:
                new Date().getFullYear() + '-' + (new Date().getMonth() + 1)
        }
    },
    computed: {
        ChartName() {
            if (!this.showMutiLine) {
                return (
                    (this.SelectNode.FullName || '') + '实时变化数据(10秒刷新)'
                )
            } else {
                return (this.GroupName || '') + '变化数据'
            }
        }
    },
    watch: {
        $route: {
            handler: function (val, oldVal) {
                // console.log('val==',val,'old',oldVal,)
                const group = val.params.group;
                this.getActiveName(group);
                /// this.getOptionList(group)

                // this.EncoderId = val.params.id
                // this.Group = this.$route.params.group
                // this.calcDefaultDataNode()
                // if (val.params.sid) {
                //     this.NodeId = val.params.sid
                // } else {
                //     this.NodeId =
                //         this.NodeOptions.length > 0
                //             ? this.NodeOptions[0].value
                //             : ''
                // }
            }
        },
        NodeId(val) {
            // if (val) {
            //     this.SelectNode = this.DataNodes.find(t => t.NodeId === val)
            //     if (!this.showMutiLine) {
            //         this.$refs.realchart.loadData(this.NodeId)
            //     }
            //     this.loadHistoryData()
            // }
        },
        Group() {
            // if (this.showMutiLine) {
            //     this.$refs.mutichart.loadData(
            //         // formatDate(this.selectMonth, 'yyyy'),
            //         // formatDate(this.selectMonth, 'MM'),
            //         // this.GroupNodes.map(t => t.NodeId).join(',')

            //         formatDate(this.selectMonth, 'yyyy-MM-dd'),
            //         this.getLastDay(this.selectMonth),
            //         this.EncoderId,
            //         this.queryName,
            //         this.valueParamList,
            //     )
            // }
        }
    },
    mounted() {
        //console.log('-----------',this.$route)
        this.EncoderId = this.$route.params.id
        this.Group = this.$route.params.group;
        this.getActiveName(this.Group);
        // this.getTableData();
        // this.getOptionList(this.Group)
        // console.log("this.EncoderId=",this.EncoderId,"-- this.Group--", this.Group)
        // this.loadDataNode().then(res => {
        //     this.calcDefaultDataNode()
        //     if (this.$route.params.sid) {
        //         this.NodeId = this.$route.params.sid
        //     } else {
        //         this.NodeId =
        //             this.NodeOptions.length > 0 ? this.NodeOptions[0].value : ''
        //     }
        //     this.SelectNode = this.DataNodes.find(t => t.NodeId === this.NodeId)
        //     this.loadHistoryData()
        //     this.$refs.realchart.loadData(
        //         // this.GroupNodes.map(t => t.NodeId)
        //         this.NodeId
        //     )
        // })
        // console.log('selectMonth', this.EncoderId)
    },
    methods: {
        // temperature-soil, conductivity, moisture, salinity
        getTableData() {
            console.log("this.queryName==", this.queryName)
            const param = {
                key: this.EncoderId,//2304270013,
                //  key:2304270013,
                metrics: this.queryName,
                begin: formatDate(this.queryDate[0], 'yyyy-MM-dd'),
                end: formatDate(this.queryDate[1], 'yyyy-MM-dd'),
                page: this.pageIndex,
                rows: this.pageRows
            };
            get(`/metrics/list?${objectToParams(param)}`).then(res => {
                if (res.data) {
                    let temp = [];
                    forEach(res.data.rows, (item, index) => {
                        let valueList = [];
                        for (var key in item) {
                            if (this.valueParamList.indexOf(key) !== -1) {
                                valueList.push(item[key])
                            }
                        }

                        temp.push({
                            rowNum: index,
                            FullName: this.type,
                            Value: valueList.join("/"),
                            // Value:`${item.temperature20CM}/${item.temperature40CM}/${item.temperature60CM}/${item.temperature80CM}`,
                            ReportTime: item.receivedAt
                        })
                    });
                    this.tableData = temp;
                    this.totalTableDataCount = res.data.rowTotal
                    // console.log("res===",res)
                }
            })
        },
        getOptionList(param) {
            let temp = [{ label: this.type, key: "" }];
            forEach(soilParamList, item => {
                if (item.key.indexOf(param) !== -1) {
                    // console.log("cccc",item)
                    temp.push({ ...item, label: "土壤" + item.label });
                }
            });
            this.NodeId = "";
            this.NodeOptions = temp;
        },
        getActiveName(param) {
            // this.pageRows=50;
            this.pageIndex = 1;
            this.totalTableDataCount = 0;
            this.tableData = [];
            forEach(soilDetailList, item => {
                if (param.indexOf(item.to.params.type) !== -1) {
                    this.type = item.name;
                    this.queryName = item.to.params.queryParam;
                    this.valueParamList = item.to.params.valueParam;
                }
            })
            this.getOptionList(param)
            this.getTableData();
            this.$refs.mutichart.loadData(

                formatDate(this.selectMonth, 'yyyy-MM-dd'),
                this.getLastDay(this.selectMonth),
                this.EncoderId,
                this.queryName,
                this.valueParamList,
            )
        },
        // 加载设备的数据
        loadDataNode() {
            return new Promise((resolve, reject) => {
                this.$request('data', 'encoder', {
                    encoderid: this.EncoderId
                }).then(res => {
                    if (res.code === 1) {
                        this.Encoder = res.data.Encoder
                        this.DataNodes = res.data.Sensors
                        resolve()
                    } else {
                        reject(new Error(''))
                    }
                })
            })
        },
        // 计算节点信息
        calcDefaultDataNode() {
            switch (this.Group.toLowerCase()) {
                case 'temperature':
                    this.GroupNodes = this.DataNodes.filter(
                        t => [125, 152, 157, 162].indexOf(t.Resource) >= 0
                    )
                    this.GroupName = '土壤温度'
                    break
                case 'humidity':
                    this.GroupNodes = this.DataNodes.filter(
                        t => [126, 153, 158, 163].indexOf(t.Resource) >= 0
                    )
                    this.GroupName = '土壤湿度'
                    break
                case 'salinity':
                    this.GroupNodes = this.DataNodes.filter(
                        t => [128, 155, 160, 165].indexOf(t.Resource) >= 0
                    )
                    this.GroupName = '土壤盐分'
                    break
                case 'ph':
                    this.GroupNodes = this.DataNodes.filter(
                        t => [127, 154, 159, 164].indexOf(t.Resource) >= 0
                    )
                    this.GroupName = '土壤pH'
                    break
                case 'conductivity':
                    this.GroupNodes = this.DataNodes.filter(
                        t => [129, 156, 161, 166].indexOf(t.Resource) >= 0
                    )
                    this.GroupName = '土壤电导率'
                    break
                default:
                    break
            }
            this.NodeOptions = this.GroupNodes.map(t => {
                return {
                    value: t.NodeId,
                    label: t.FullName
                }
            })
        },
        loadHistoryData() {
            if (this.pageIndex === 1) {
                this.tableData = []
            }
            // 加载设备的数据
            this.$request('history', 'data', {
                rows: this.pageRows,
                page: this.pageIndex,
                nodeid: this.NodeId,
                begindate:
                    this.queryDate == null
                        ? ''
                        : formatDate(this.queryDate[0], 'yyyy-MM-dd hh:mm:ss'),
                endate:
                    this.queryDate == null
                        ? ''
                        : formatDate(this.queryDate[1], 'yyyy-MM-dd hh:mm:ss')
            }).then(res => {
                if (res.code === 1) {
                    this.tableData = res.data.rows
                    this.totalTableDataCount = res.data.records
                    this.tableCostTime = res.data.costtime
                }
            })
        },
        tableRowClassName({ row, rowIndex }) {
            if (rowIndex % 2 === 0) {
                return 'bg-w'
            } else {
                return 'bg-mf5'
            }
        },
        handleSizeChange(rows) {
            this.pageRows = rows;
            this.getTableData();
            // this.loadHistoryData()
            // console.log('handleSizeChange', rows)
        },
        handleCurrentChange(page) {
            this.pageIndex = page;
            this.getTableData();
            //   this.loadHistoryData()
            console.log('handleCurrentChange', page)
        },
        showHistoryDialog() {
            this.$refs.historydialog.show(this.NodeId)
        },
        downLoadHistory() {
            const param = {
                key: this.EncoderId,//2304270013,
                //  key:2304270013,
                metrics: this.queryName,
                begin: formatDate(this.queryDate[0], 'yyyy-MM-dd'),
                end: formatDate(this.queryDate[1], 'yyyy-MM-dd'),
                page: 1,
                rows: 1000
            };
            get(`/metrics/list?${objectToParams(param)}`).then(res => {
                if (res && res.data && res.data.rows) {
                    let temp = [];
                    forEach(res.data.rows, (item, index) => {
                        let valueList = [];
                        for (var key in item) {
                            if (this.valueParamList.indexOf(key) !== -1) {
                                valueList.push(item[key])
                            }
                        }

                        temp.push({
                            FullName: this.type,
                            Value: valueList.join("/"),
                            // Value:`${item.temperature20CM}/${item.temperature40CM}/${item.temperature60CM}/${item.temperature80CM}`,
                            ReportTime: item.receivedAt
                        })
                    });

                    const obj = {
                        list: temp,
                        header: [{ label: "传感器名", name: "FullName" }, { label: "采集值", name: "Value" },
                        { label: "采集时间", name: "ReportTime" }
                        ],
                        headerTitle: temp[0].FullName + "导出表"
                    };

                    downLoadExcel(obj);
                } else {
                    this.$message({
                        message: '暂无数据导出',
                        type: 'warning'
                    });
                }
            })
        },
        search() {
            this.getTableData();
            // this.loadHistoryData()
        },
        showMutiLineChange(e) {
            if (e) {
                this.$refs.mutichart.loadData(
                    formatDate(e, 'yyyy-MM-dd'),
                    this.getLastDay(e),
                    this.EncoderId,
                    this.queryName,
                    this.valueParamList,
                )
            } else {
                this.$refs.realchart.loadData(this.NodeId)
            }
        },
        //获取当前月的最后一天
        getLastDay(date) {

            var year = new Date(date).getFullYear(); //获取年份
            var month = new Date(date).getMonth() + 1; //获取月份
            var lastDate = new Date(year, month, 0).getDate(); //获取当月最后一日
            month = month < 10 ? '0' + month : month; //月份补 0
            return [year, month, lastDate].join("-")
        },
        MonthChange() {
            const begin = this.queryDate == null ? '' : formatDate(this.queryDate[0], 'yyyy-MM-dd');
            const end = this.queryDate == null ? '' : formatDate(this.queryDate[1], 'yyyy-MM-dd');
            this.$refs.mutichart.loadData(
                begin,//,formatDate(e, 'yyyy-MM-dd'),
                end,
                // this.getLastDay(e),
                this.EncoderId,
                this.queryName,
                this.valueParamList,

                // this.GroupNodes.map(t => t.NodeId).join(',')
            )
        }
    }
}
</script>
<style lang='less' scoped>
.content {
    position: relative;
    left: 165px;
    top: 90px;
    width: calc(100vw - 175px);
    height: calc(100vh - 90px);
    overflow-y: auto;
    overflow-x: hidden;
    padding: 30px;
}

.headercolumn {
    th {
        padding: 0 0;
        line-height: 45px;
        background-color: #e2eff6;
        color: #000;
        text-align: center;
        font-size: 14px;
    }
}

.datarow {
    text-align: center;
    line-height: 45px;
    color: #181b24;
    font-size: 14px;
}

.el-table .bg-mf5>td {
    background-color: #f5f9fa !important;
    border-bottom: none;
}

.el-table .bg-w>td {
    background-color: #fff !important;
    border-bottom: none;
}

.paging-memo {
    color: #485060;
    font-size: 14px;
    line-height: 24px;
}

.operate {
    line-height: 34px;
    color: #6d7996;

    a {
        color: #6d7996;
        font-size: 14px;
        display: inline-block;
        margin-left: 10px;
    }

    .chart {
        background: url(../../../assets/his-1.png) no-repeat left center;
        padding-left: 20px;
    }

    .export {
        background: url(../../../assets/his-2.png) no-repeat left center;
        padding-left: 20px;
    }

    .other {
        background: url(../../../assets/his-3.png) no-repeat left center;
        padding-left: 20px;
    }
}

.hs-dialog {
    border-radius: 6px;
    overflow: hidden;

    .el-dialog__header {
        background: url(../../../assets/title_top.jpg) no-repeat;
        background-size: 100% 100%;
        padding: 10px 20px;

        .el-dialog__headerbtn {
            top: 15px;
        }
    }

    .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 16px;
        font-weight: bold;
    }

    .hs-dialog-title {
        font-size: 18px;
        color: white;
    }
}

.query-form {
    .el-form-item {
        margin-bottom: 0;
    }
}
</style>
